import { createActionGroup, props } from '@ngrx/store';
import {
  InsWebsocketMessageRequest,
  QueryWebsocketMessageRequest,
  SubWebsocketMessageRequest,
  UpdWebsocketMessageRequest,
} from '@qtek/core/websockets-core';
import { AiChat, AiChatEvent } from '@qtek/shared/models';

export const AiChatActions = createActionGroup({
  source: 'AI Chat',
  events: {
    'Subscribe Chats': props<{
      payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>;
    }>(),
    'Unsubscribe Chats': props<{ mysid: string }>(),

    'Get Chats': props<{
      payload: Omit<QueryWebsocketMessageRequest, 'ent' | 'op'>;
    }>(),
    'Get Chats Success': props<{ chats: AiChat[]; mysid?: string }>(),
    'Get Chats Failure': props<{ error: any }>(),

    'Create Chat': props<{
      payload: Omit<InsWebsocketMessageRequest, 'ent' | 'op'>;
    }>(),

    'Create Chat Success': props<{ chat: AiChat; mysid?: string }>(),
    'Create Chat Failure': props<{ error: any }>(),

    'Update Chat': props<{
      payload: Omit<UpdWebsocketMessageRequest, 'ent' | 'op'>;
    }>(),
    'Update Chat Success': props<{ chat: AiChat }>(),
    'Update Chat Failure': props<{ error: any }>(),

    'Subscribe Chat Events': props<{
      payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>;
    }>(),
    'Unsubscribe Chat Events': props<{ mysid: string }>(),

    'Get Chat Events': props<{
      payload: Omit<QueryWebsocketMessageRequest, 'ent' | 'op'>;
    }>(),
    'Get Chat Events Success': props<{
      events: AiChatEvent[];
      mysid?: string;
    }>(),
    'Get Chat Events Failure': props<{ error: any }>(),

    'Send Message': props<{
      payload: Omit<InsWebsocketMessageRequest, 'ent' | 'op'>;
    }>(),
  },
});
